module.exports = __webpack_public_path__ + "assets/media/evening.e5deaca0.mp3";